import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\FetchItemWikiItemsController::__invoke
* @see app/Http/Controllers/Invoice/FetchItemWikiItemsController.php
* @route '/api/linked-item-wiki-for-modal'
*/
const FetchItemWikiItemsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemWikiItemsController.url(options),
    method: 'get',
})

FetchItemWikiItemsController.definition = {
    methods: ["get","head"],
    url: '/api/linked-item-wiki-for-modal',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\FetchItemWikiItemsController::__invoke
* @see app/Http/Controllers/Invoice/FetchItemWikiItemsController.php
* @route '/api/linked-item-wiki-for-modal'
*/
FetchItemWikiItemsController.url = (options?: RouteQueryOptions) => {
    return FetchItemWikiItemsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\FetchItemWikiItemsController::__invoke
* @see app/Http/Controllers/Invoice/FetchItemWikiItemsController.php
* @route '/api/linked-item-wiki-for-modal'
*/
FetchItemWikiItemsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemWikiItemsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\FetchItemWikiItemsController::__invoke
* @see app/Http/Controllers/Invoice/FetchItemWikiItemsController.php
* @route '/api/linked-item-wiki-for-modal'
*/
FetchItemWikiItemsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemWikiItemsController.url(options),
    method: 'head',
})

export default FetchItemWikiItemsController